import { EntitlementsProject } from '@adsk/alloy-provider';

import { parseProductAndToolKey } from './defaultProductAndToolHelpers';

type Product = EntitlementsProject['products'][0];

export function getSelectedTool(
  project: EntitlementsProject,
  selectedProduct: Product,
  selectedProductAndToolId?: string,
) {
  const { productId: selectedProductId, toolId: selectedToolId } =
    selectedProductAndToolId
      ? parseProductAndToolKey(selectedProductAndToolId)
      : { productId: undefined, toolId: undefined };
  if (selectedProductId && selectedProduct.key === selectedProductId) {
    return selectedProduct.tools?.find((tool) => tool.key === selectedToolId);
  }
  return undefined;
}
